import { render, staticRenderFns } from "./TheParentFolder.vue?vue&type=template&id=b7542184&scoped=true"
import script from "./TheParentFolder.vue?vue&type=script&lang=js"
export * from "./TheParentFolder.vue?vue&type=script&lang=js"
import style0 from "./TheParentFolder.vue?vue&type=style&index=0&id=b7542184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7542184",
  null
  
)

export default component.exports